import { render, staticRenderFns } from "./IndexDoDetail.vue?vue&type=template&id=d606d0f4&scoped=true"
import script from "./IndexDoDetail.vue?vue&type=script&lang=js"
export * from "./IndexDoDetail.vue?vue&type=script&lang=js"
import style0 from "./IndexDoDetail.vue?vue&type=style&index=0&id=d606d0f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d606d0f4",
  null
  
)

export default component.exports